import React from 'react';
import { C } from '../data/constants.js';

interface PillOption {
  label: string;
  value: string;
}

interface PillToggleProps {
  options: PillOption[];
  value: string;
  onChange: (value: string) => void;
  size?: 'sm' | 'md';
}

export function PillToggle({
  options,
  value,
  onChange,
  size = 'sm',
}: PillToggleProps): React.ReactElement {
  return (
    <div
      style={{
        display: 'inline-flex',
        gap: 2,
        padding: 3,
        background: 'rgba(255,255,255,0.04)',
        borderRadius: 10,
        border: `1px solid ${C.cardBorder}`,
        flexWrap: 'wrap',
      }}
    >
      {options.map((opt) => (
        <button
          key={opt.value}
          onClick={() => onChange(opt.value)}
          style={{
            padding: size === 'sm' ? '6px 14px' : '8px 18px',
            borderRadius: 8,
            border: 'none',
            cursor: 'pointer',
            fontSize: size === 'sm' ? 12 : 13,
            fontWeight: 500,
            fontFamily: "'DM Sans', sans-serif",
            transition: 'all 0.2s',
            background: value === opt.value ? 'rgba(0, 207, 160, 0.15)' : 'transparent',
            color: value === opt.value ? C.accent : 'rgba(255,255,255,0.4)',
            whiteSpace: 'nowrap',
          }}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
